import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    message: {
        display: 'flex',
        flexDirection: 'column',
    },
    dateSeparator: {
        display: 'flex',
        justifyContent: 'center',
        margin: '16px 0px 6px',
        '& span': {
            fontSize: 11.5,
            fontWeight: 500,
            lineHeight: 1.5,
            color: theme.palette.text.secondary,
            background: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 12,
            padding: '2px 12px',
        },
    },
    row: {
        display: 'flex',
        margin: '1px 0px',
    },
    // A little air between runs of messages from the same side.
    rowStart: {
        marginTop: 8,
    },
    rowMine: {
        justifyContent: 'flex-end',
    },
    bubble: {
        position: 'relative',
        maxWidth: 'min(72%, 560px)',
        padding: '7px 12px',
        borderRadius: 16,
        wordBreak: 'break-word',
        boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.06)',
    },
    content: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        columnGap: 12,
    },
    bubbleTheirs: {
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
    },
    bubbleMine: {
        background: theme.palette.primary.light,
        color: '#fff',
        '& a': {
            color: '#fff',
        },
    },
    // Only the first bubble of a run gets the "tail" corner.
    tailTheirs: {
        borderTopLeftRadius: 4,
    },
    tailMine: {
        borderTopRightRadius: 4,
    },
    bubbleFailed: {
        opacity: 0.85,
        boxShadow: `0 0 0 1px ${theme.palette.secondary.main}`,
    },
    text: {
        flex: '1 1 auto',
        minWidth: 0,
        whiteSpace: 'pre-wrap',
        fontSize: 14.5,
        lineHeight: 1.4,
    },
    emojiOnly: {
        fontSize: 36,
        lineHeight: 1.2,
    },
    link: {
        color: 'inherit',
        textDecoration: 'underline',
    },
    media: {
        display: 'block',
        maxWidth: 256,
        width: '100%',
        borderRadius: 12,
        marginBottom: 4,
        cursor: 'pointer',
    },
    meta: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 4,
        fontSize: 10.5,
        lineHeight: 1.6,
        opacity: 0.75,
        whiteSpace: 'nowrap',
        fontVariantNumeric: 'tabular-nums',
        '& svg': {
            fontSize: 14,
        },
    },
    metaFailed: {
        color: theme.palette.secondary.main,
        opacity: 1,
    },
    failedNote: {
        fontSize: 12,
        color: theme.palette.secondary.main,
        margin: '2px 12px 8px 12px',
    },
    failedNoteMine: {
        textAlign: 'right',
    },
    failedNoteRetry: {
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}));

export { useStyles }
